// extracted by mini-css-extract-plugin
export default {"galleryThumbnail":"c-p_go","galleryThumbnail_active":"c-p_gp","galleryThumbnail__image":"c-p_gq"};